var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoZinliButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_30867)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9755 20.5H9.62305L13.2384 16.4412H20.9755C21.2657 16.4412 21.5004 16.6747 21.5004 16.966V19.9843C21.5004 20.2695 21.2626 20.5 20.9755 20.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4004 3.5H4.72307C4.43285 3.5 4.19821 3.73358 4.19821 4.0157V7.03408C4.19821 7.3253 4.43594 7.55889 4.72307 7.55889H13.2721L2.6298 19.6415C2.33341 19.9782 2.57731 20.5 3.03116 20.5H6.79473C6.94293 20.5 7.09112 20.4393 7.1961 20.318L21.2531 4.35849C21.5588 4.02177 21.3149 3.5 20.8518 3.5H18.4004Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_30867"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 17,
    fill: "white",
    transform: "translate(2.5 3.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoZinliButton);
export default __webpack_public_path__ + "static/media/logo-zinli-button.36dbeff95c7c105cad9c899b3302e7a9.svg";
export { ForwardRef as ReactComponent };